// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import { getApiV1ChangelogsResponseTransformer, getApiV1ChoreBoardResponseTransformer, getApiV1ChoreInstancesByIdResponseTransformer, getApiV1ChoreInstancesResponseTransformer, getApiV1PerformedChoresByIdResponseTransformer, getApiV1PerformedChoresResponseTransformer, postApiV1ChoreInstancesOneTimeResponseTransformer, postApiV1ChoreInstancesResponseTransformer, postApiV1PerformedChoresResponseTransformer, putApiV1ChoreInstancesByIdResponseTransformer } from './transformers.gen';
import type { DeleteApiV1CategoriesByIdData, DeleteApiV1CategoriesByIdErrors, DeleteApiV1CategoriesByIdResponses, DeleteApiV1ChoreInstancesByIdData, DeleteApiV1ChoreInstancesByIdErrors, DeleteApiV1ChoreInstancesByIdResponses, DeleteApiV1ChoresByIdData, DeleteApiV1ChoresByIdErrors, DeleteApiV1ChoresByIdResponses, DeleteApiV1DevicesByInstallationIdData, DeleteApiV1DevicesByInstallationIdResponses, DeleteApiV1PerformedChoresByIdData, DeleteApiV1PerformedChoresByIdErrors, DeleteApiV1PerformedChoresByIdResponses, DeleteApiV1PrizeSuggestionsByIdData, DeleteApiV1PrizeSuggestionsByIdErrors, DeleteApiV1PrizeSuggestionsByIdResponses, GetApiV1CategoriesByIdData, GetApiV1CategoriesByIdErrors, GetApiV1CategoriesByIdResponses, GetApiV1CategoriesData, GetApiV1CategoriesResponses, GetApiV1ChangelogsData, GetApiV1ChangelogsResponses, GetApiV1ChoreBoardData, GetApiV1ChoreBoardResponses, GetApiV1ChoreInstancesByIdData, GetApiV1ChoreInstancesByIdErrors, GetApiV1ChoreInstancesByIdResponses, GetApiV1ChoreInstancesData, GetApiV1ChoreInstancesResponses, GetApiV1ChoresByIdData, GetApiV1ChoresByIdErrors, GetApiV1ChoresByIdResponses, GetApiV1ChoresData, GetApiV1ChoresResponses, GetApiV1HouseholdsByIdData, GetApiV1HouseholdsByIdErrors, GetApiV1HouseholdsByIdResponses, GetApiV1HouseholdsData, GetApiV1HouseholdsInvitationData, GetApiV1HouseholdsInvitationResponses, GetApiV1HouseholdsResponses, GetApiV1LevelsByIdData, GetApiV1LevelsByIdErrors, GetApiV1LevelsByIdResponses, GetApiV1LevelsData, GetApiV1LevelsResponses, GetApiV1MonthlyPrizeSelectionsByIdData, GetApiV1MonthlyPrizeSelectionsByIdErrors, GetApiV1MonthlyPrizeSelectionsByIdResponses, GetApiV1MonthlyPrizeSelectionsData, GetApiV1MonthlyPrizeSelectionsResponses, GetApiV1MonthlyResultsByIdData, GetApiV1MonthlyResultsByIdErrors, GetApiV1MonthlyResultsByIdResponses, GetApiV1MonthlyResultsData, GetApiV1MonthlyResultsResponses, GetApiV1NotificationPreferencesData, GetApiV1NotificationPreferencesResponses, GetApiV1PerformedChoresByIdData, GetApiV1PerformedChoresByIdErrors, GetApiV1PerformedChoresByIdResponses, GetApiV1PerformedChoresData, GetApiV1PerformedChoresResponses, GetApiV1PrizeSuggestionsByIdData, GetApiV1PrizeSuggestionsByIdErrors, GetApiV1PrizeSuggestionsByIdResponses, GetApiV1PrizeSuggestionsData, GetApiV1PrizeSuggestionsResponses, GetApiV1RanksCategoriesByCategoryIdData, GetApiV1RanksCategoriesByCategoryIdErrors, GetApiV1RanksCategoriesByCategoryIdResponses, GetApiV1RanksCategoriesData, GetApiV1RanksCategoriesResponses, GetApiV1UsersByIdData, GetApiV1UsersByIdErrors, GetApiV1UsersByIdResponses, GetApiV1UsersData, GetApiV1UsersResponses, PostApiV1CategoriesData, PostApiV1CategoriesErrors, PostApiV1CategoriesResponses, PostApiV1ChangelogsReadData, PostApiV1ChangelogsReadResponses, PostApiV1ChoreInstancesData, PostApiV1ChoreInstancesErrors, PostApiV1ChoreInstancesOneTimeData, PostApiV1ChoreInstancesOneTimeErrors, PostApiV1ChoreInstancesOneTimeResponses, PostApiV1ChoreInstancesResponses, PostApiV1ChoresData, PostApiV1ChoresErrors, PostApiV1ChoresResponses, PostApiV1DevicesTestData, PostApiV1DevicesTestResponses, PostApiV1HouseholdsJoinData, PostApiV1HouseholdsJoinErrors, PostApiV1HouseholdsJoinResponses, PostApiV1HouseholdsOnboardingData, PostApiV1HouseholdsOnboardingErrors, PostApiV1HouseholdsOnboardingResponses, PostApiV1MonthlyPrizeSelectionsData, PostApiV1MonthlyPrizeSelectionsErrors, PostApiV1MonthlyPrizeSelectionsResponses, PostApiV1PerformedChoresData, PostApiV1PerformedChoresErrors, PostApiV1PerformedChoresResponses, PostApiV1PrizeSuggestionsData, PostApiV1PrizeSuggestionsResponses, PostApiV1UsersData, PostApiV1UsersErrors, PostApiV1UsersResponses, PutApiV1ChoreInstancesByIdData, PutApiV1ChoreInstancesByIdErrors, PutApiV1ChoreInstancesByIdResponses, PutApiV1ChoresByIdData, PutApiV1ChoresByIdErrors, PutApiV1ChoresByIdResponses, PutApiV1DevicesData, PutApiV1DevicesResponses, PutApiV1MonthlyResultsByIdChoosePrizeData, PutApiV1MonthlyResultsByIdChoosePrizeErrors, PutApiV1MonthlyResultsByIdChoosePrizeResponses, PutApiV1MonthlyResultsByIdPatchSuggestionsData, PutApiV1MonthlyResultsByIdPatchSuggestionsErrors, PutApiV1MonthlyResultsByIdPatchSuggestionsResponses, PutApiV1MonthlyResultsByIdSetFinalPrizeData, PutApiV1MonthlyResultsByIdSetFinalPrizeErrors, PutApiV1MonthlyResultsByIdSetFinalPrizeResponses, PutApiV1NotificationPreferencesData, PutApiV1NotificationPreferencesResponses, PutApiV1PrizeSuggestionsByIdData, PutApiV1PrizeSuggestionsByIdErrors, PutApiV1PrizeSuggestionsByIdResponses, PutApiV1UsersByIdData, PutApiV1UsersByIdErrors, PutApiV1UsersByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getApiV1MonthlyPrizeSelections = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1MonthlyPrizeSelectionsData, ThrowOnError>): RequestResult<GetApiV1MonthlyPrizeSelectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1MonthlyPrizeSelectionsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyPrizeSelections',
    ...options
});

export const postApiV1MonthlyPrizeSelections = <ThrowOnError extends boolean = false>(options: Options<PostApiV1MonthlyPrizeSelectionsData, ThrowOnError>): RequestResult<PostApiV1MonthlyPrizeSelectionsResponses, PostApiV1MonthlyPrizeSelectionsErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1MonthlyPrizeSelectionsResponses, PostApiV1MonthlyPrizeSelectionsErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyPrizeSelections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1MonthlyPrizeSelectionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1MonthlyPrizeSelectionsByIdData, ThrowOnError>): RequestResult<GetApiV1MonthlyPrizeSelectionsByIdResponses, GetApiV1MonthlyPrizeSelectionsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1MonthlyPrizeSelectionsByIdResponses, GetApiV1MonthlyPrizeSelectionsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyPrizeSelections/{id}',
    ...options
});

export const getApiV1MonthlyResults = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1MonthlyResultsData, ThrowOnError>): RequestResult<GetApiV1MonthlyResultsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1MonthlyResultsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyResults',
    ...options
});

export const getApiV1MonthlyResultsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1MonthlyResultsByIdData, ThrowOnError>): RequestResult<GetApiV1MonthlyResultsByIdResponses, GetApiV1MonthlyResultsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1MonthlyResultsByIdResponses, GetApiV1MonthlyResultsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyResults/{id}',
    ...options
});

export const putApiV1MonthlyResultsByIdPatchSuggestions = <ThrowOnError extends boolean = false>(options: Options<PutApiV1MonthlyResultsByIdPatchSuggestionsData, ThrowOnError>): RequestResult<PutApiV1MonthlyResultsByIdPatchSuggestionsResponses, PutApiV1MonthlyResultsByIdPatchSuggestionsErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1MonthlyResultsByIdPatchSuggestionsResponses, PutApiV1MonthlyResultsByIdPatchSuggestionsErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyResults/{id}/patch-suggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1MonthlyResultsByIdChoosePrize = <ThrowOnError extends boolean = false>(options: Options<PutApiV1MonthlyResultsByIdChoosePrizeData, ThrowOnError>): RequestResult<PutApiV1MonthlyResultsByIdChoosePrizeResponses, PutApiV1MonthlyResultsByIdChoosePrizeErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1MonthlyResultsByIdChoosePrizeResponses, PutApiV1MonthlyResultsByIdChoosePrizeErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyResults/{id}/choose-prize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const putApiV1MonthlyResultsByIdSetFinalPrize = <ThrowOnError extends boolean = false>(options: Options<PutApiV1MonthlyResultsByIdSetFinalPrizeData, ThrowOnError>): RequestResult<PutApiV1MonthlyResultsByIdSetFinalPrizeResponses, PutApiV1MonthlyResultsByIdSetFinalPrizeErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1MonthlyResultsByIdSetFinalPrizeResponses, PutApiV1MonthlyResultsByIdSetFinalPrizeErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/MonthlyResults/{id}/set-final-prize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1PrizeSuggestions = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PrizeSuggestionsData, ThrowOnError>): RequestResult<GetApiV1PrizeSuggestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1PrizeSuggestionsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PrizeSuggestions',
    ...options
});

export const postApiV1PrizeSuggestions = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PrizeSuggestionsData, ThrowOnError>): RequestResult<PostApiV1PrizeSuggestionsResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostApiV1PrizeSuggestionsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PrizeSuggestions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1PrizeSuggestionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1PrizeSuggestionsByIdData, ThrowOnError>): RequestResult<DeleteApiV1PrizeSuggestionsByIdResponses, DeleteApiV1PrizeSuggestionsByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1PrizeSuggestionsByIdResponses, DeleteApiV1PrizeSuggestionsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PrizeSuggestions/{id}',
    ...options
});

export const getApiV1PrizeSuggestionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PrizeSuggestionsByIdData, ThrowOnError>): RequestResult<GetApiV1PrizeSuggestionsByIdResponses, GetApiV1PrizeSuggestionsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PrizeSuggestionsByIdResponses, GetApiV1PrizeSuggestionsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PrizeSuggestions/{id}',
    ...options
});

export const putApiV1PrizeSuggestionsById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1PrizeSuggestionsByIdData, ThrowOnError>): RequestResult<PutApiV1PrizeSuggestionsByIdResponses, PutApiV1PrizeSuggestionsByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1PrizeSuggestionsByIdResponses, PutApiV1PrizeSuggestionsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PrizeSuggestions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Registers the device for push notifications, or refreshes it. Safe to call on every app start.
 *
 * An installation that belonged to another user (account switch on the same phone) moves to the caller.
 */
export const putApiV1Devices = <ThrowOnError extends boolean = false>(options: Options<PutApiV1DevicesData, ThrowOnError>): RequestResult<PutApiV1DevicesResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutApiV1DevicesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Devices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Removes the device, e.g. on logout. Succeeds if it is already gone.
 */
export const deleteApiV1DevicesByInstallationId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1DevicesByInstallationIdData, ThrowOnError>): RequestResult<DeleteApiV1DevicesByInstallationIdResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1DevicesByInstallationIdResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Devices/{installationId}',
    ...options
});

/**
 * Sends a test notification to all devices of the calling user.
 */
export const postApiV1DevicesTest = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1DevicesTestData, ThrowOnError>): RequestResult<PostApiV1DevicesTestResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PostApiV1DevicesTestResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Devices/test',
    ...options
});

export const getApiV1NotificationPreferences = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1NotificationPreferencesData, ThrowOnError>): RequestResult<GetApiV1NotificationPreferencesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1NotificationPreferencesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/NotificationPreferences',
    ...options
});

export const putApiV1NotificationPreferences = <ThrowOnError extends boolean = false>(options: Options<PutApiV1NotificationPreferencesData, ThrowOnError>): RequestResult<PutApiV1NotificationPreferencesResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutApiV1NotificationPreferencesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/NotificationPreferences',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Changelogs = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ChangelogsData, ThrowOnError>): RequestResult<GetApiV1ChangelogsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1ChangelogsResponses, unknown, ThrowOnError>({
    responseTransformer: getApiV1ChangelogsResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Changelogs',
    ...options
});

export const postApiV1ChangelogsRead = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ChangelogsReadData, ThrowOnError>): RequestResult<PostApiV1ChangelogsReadResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostApiV1ChangelogsReadResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Changelogs/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Households = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1HouseholdsData, ThrowOnError>): RequestResult<GetApiV1HouseholdsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1HouseholdsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Households',
    ...options
});

export const getApiV1HouseholdsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1HouseholdsByIdData, ThrowOnError>): RequestResult<GetApiV1HouseholdsByIdResponses, GetApiV1HouseholdsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1HouseholdsByIdResponses, GetApiV1HouseholdsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Households/{id}',
    ...options
});

export const getApiV1HouseholdsInvitation = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1HouseholdsInvitationData, ThrowOnError>): RequestResult<GetApiV1HouseholdsInvitationResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1HouseholdsInvitationResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Households/invitation',
    ...options
});

export const postApiV1HouseholdsOnboarding = <ThrowOnError extends boolean = false>(options: Options<PostApiV1HouseholdsOnboardingData, ThrowOnError>): RequestResult<PostApiV1HouseholdsOnboardingResponses, PostApiV1HouseholdsOnboardingErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1HouseholdsOnboardingResponses, PostApiV1HouseholdsOnboardingErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Households/onboarding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1HouseholdsJoin = <ThrowOnError extends boolean = false>(options: Options<PostApiV1HouseholdsJoinData, ThrowOnError>): RequestResult<PostApiV1HouseholdsJoinResponses, PostApiV1HouseholdsJoinErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1HouseholdsJoinResponses, PostApiV1HouseholdsJoinErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Households/join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Levels = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1LevelsData, ThrowOnError>): RequestResult<GetApiV1LevelsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1LevelsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Levels',
    ...options
});

export const getApiV1LevelsById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LevelsByIdData, ThrowOnError>): RequestResult<GetApiV1LevelsByIdResponses, GetApiV1LevelsByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1LevelsByIdResponses, GetApiV1LevelsByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Levels/{id}',
    ...options
});

export const getApiV1RanksCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1RanksCategoriesData, ThrowOnError>): RequestResult<GetApiV1RanksCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1RanksCategoriesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Ranks/categories',
    ...options
});

export const getApiV1RanksCategoriesByCategoryId = <ThrowOnError extends boolean = false>(options: Options<GetApiV1RanksCategoriesByCategoryIdData, ThrowOnError>): RequestResult<GetApiV1RanksCategoriesByCategoryIdResponses, GetApiV1RanksCategoriesByCategoryIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1RanksCategoriesByCategoryIdResponses, GetApiV1RanksCategoriesByCategoryIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Ranks/categories/{categoryId}',
    ...options
});

export const getApiV1Users = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1UsersData, ThrowOnError>): RequestResult<GetApiV1UsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1UsersResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Users',
    ...options
});

export const postApiV1Users = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UsersData, ThrowOnError>): RequestResult<PostApiV1UsersResponses, PostApiV1UsersErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1UsersResponses, PostApiV1UsersErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1UsersById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UsersByIdData, ThrowOnError>): RequestResult<GetApiV1UsersByIdResponses, GetApiV1UsersByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1UsersByIdResponses, GetApiV1UsersByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Users/{id}',
    ...options
});

export const putApiV1UsersById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UsersByIdData, ThrowOnError>): RequestResult<PutApiV1UsersByIdResponses, PutApiV1UsersByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1UsersByIdResponses, PutApiV1UsersByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Categories = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CategoriesData, ThrowOnError>): RequestResult<GetApiV1CategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1CategoriesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Categories',
    ...options
});

export const postApiV1Categories = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CategoriesData, ThrowOnError>): RequestResult<PostApiV1CategoriesResponses, PostApiV1CategoriesErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1CategoriesResponses, PostApiV1CategoriesErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1CategoriesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1CategoriesByIdData, ThrowOnError>): RequestResult<DeleteApiV1CategoriesByIdResponses, DeleteApiV1CategoriesByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1CategoriesByIdResponses, DeleteApiV1CategoriesByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Categories/{id}',
    ...options
});

export const getApiV1CategoriesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CategoriesByIdData, ThrowOnError>): RequestResult<GetApiV1CategoriesByIdResponses, GetApiV1CategoriesByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1CategoriesByIdResponses, GetApiV1CategoriesByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Categories/{id}',
    ...options
});

export const getApiV1ChoreBoard = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ChoreBoardData, ThrowOnError>): RequestResult<GetApiV1ChoreBoardResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1ChoreBoardResponses, unknown, ThrowOnError>({
    responseTransformer: getApiV1ChoreBoardResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreBoard',
    ...options
});

export const getApiV1ChoreInstances = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ChoreInstancesData, ThrowOnError>): RequestResult<GetApiV1ChoreInstancesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1ChoreInstancesResponses, unknown, ThrowOnError>({
    responseTransformer: getApiV1ChoreInstancesResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances',
    ...options
});

export const postApiV1ChoreInstances = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ChoreInstancesData, ThrowOnError>): RequestResult<PostApiV1ChoreInstancesResponses, PostApiV1ChoreInstancesErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1ChoreInstancesResponses, PostApiV1ChoreInstancesErrors, ThrowOnError>({
    responseTransformer: postApiV1ChoreInstancesResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ChoreInstancesById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ChoreInstancesByIdData, ThrowOnError>): RequestResult<DeleteApiV1ChoreInstancesByIdResponses, DeleteApiV1ChoreInstancesByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1ChoreInstancesByIdResponses, DeleteApiV1ChoreInstancesByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances/{id}',
    ...options
});

export const getApiV1ChoreInstancesById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ChoreInstancesByIdData, ThrowOnError>): RequestResult<GetApiV1ChoreInstancesByIdResponses, GetApiV1ChoreInstancesByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1ChoreInstancesByIdResponses, GetApiV1ChoreInstancesByIdErrors, ThrowOnError>({
    responseTransformer: getApiV1ChoreInstancesByIdResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances/{id}',
    ...options
});

export const putApiV1ChoreInstancesById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ChoreInstancesByIdData, ThrowOnError>): RequestResult<PutApiV1ChoreInstancesByIdResponses, PutApiV1ChoreInstancesByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1ChoreInstancesByIdResponses, PutApiV1ChoreInstancesByIdErrors, ThrowOnError>({
    responseTransformer: putApiV1ChoreInstancesByIdResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postApiV1ChoreInstancesOneTime = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ChoreInstancesOneTimeData, ThrowOnError>): RequestResult<PostApiV1ChoreInstancesOneTimeResponses, PostApiV1ChoreInstancesOneTimeErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1ChoreInstancesOneTimeResponses, PostApiV1ChoreInstancesOneTimeErrors, ThrowOnError>({
    responseTransformer: postApiV1ChoreInstancesOneTimeResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/ChoreInstances/one-time',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1Chores = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ChoresData, ThrowOnError>): RequestResult<GetApiV1ChoresResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1ChoresResponses, unknown, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Chores',
    ...options
});

export const postApiV1Chores = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ChoresData, ThrowOnError>): RequestResult<PostApiV1ChoresResponses, PostApiV1ChoresErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1ChoresResponses, PostApiV1ChoresErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Chores',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1ChoresById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1ChoresByIdData, ThrowOnError>): RequestResult<DeleteApiV1ChoresByIdResponses, DeleteApiV1ChoresByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1ChoresByIdResponses, DeleteApiV1ChoresByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Chores/{id}',
    ...options
});

export const getApiV1ChoresById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ChoresByIdData, ThrowOnError>): RequestResult<GetApiV1ChoresByIdResponses, GetApiV1ChoresByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1ChoresByIdResponses, GetApiV1ChoresByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Chores/{id}',
    ...options
});

export const putApiV1ChoresById = <ThrowOnError extends boolean = false>(options: Options<PutApiV1ChoresByIdData, ThrowOnError>): RequestResult<PutApiV1ChoresByIdResponses, PutApiV1ChoresByIdErrors, ThrowOnError> => (options.client ?? client).put<PutApiV1ChoresByIdResponses, PutApiV1ChoresByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/Chores/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getApiV1PerformedChores = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PerformedChoresData, ThrowOnError>): RequestResult<GetApiV1PerformedChoresResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetApiV1PerformedChoresResponses, unknown, ThrowOnError>({
    responseTransformer: getApiV1PerformedChoresResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PerformedChores',
    ...options
});

export const postApiV1PerformedChores = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PerformedChoresData, ThrowOnError>): RequestResult<PostApiV1PerformedChoresResponses, PostApiV1PerformedChoresErrors, ThrowOnError> => (options.client ?? client).post<PostApiV1PerformedChoresResponses, PostApiV1PerformedChoresErrors, ThrowOnError>({
    responseTransformer: postApiV1PerformedChoresResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PerformedChores',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteApiV1PerformedChoresById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1PerformedChoresByIdData, ThrowOnError>): RequestResult<DeleteApiV1PerformedChoresByIdResponses, DeleteApiV1PerformedChoresByIdErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiV1PerformedChoresByIdResponses, DeleteApiV1PerformedChoresByIdErrors, ThrowOnError>({
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PerformedChores/{id}',
    ...options
});

export const getApiV1PerformedChoresById = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PerformedChoresByIdData, ThrowOnError>): RequestResult<GetApiV1PerformedChoresByIdResponses, GetApiV1PerformedChoresByIdErrors, ThrowOnError> => (options.client ?? client).get<GetApiV1PerformedChoresByIdResponses, GetApiV1PerformedChoresByIdErrors, ThrowOnError>({
    responseTransformer: getApiV1PerformedChoresByIdResponseTransformer,
    security: [{
            key: 'Bearer',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'OAuth2',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v1/PerformedChores/{id}',
    ...options
});
